export const getBodyCellContent = (data, text, placeholder = '-') => {
  if (!data) {
    return placeholder;
  }

  return `${data}${text ? ` ${text}` : ''}`;
};
